'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = require('jss-theme-reactor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSortableHoc = require('react-sortable-hoc');

var _IconButton = require('../../IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Drag = require('../../SvgIcon/Drag');

var _Drag2 = _interopRequireDefault(_Drag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('SortableHandle', function () {
  return {
    sortableHandle: {
      position: 'absolute',
      top: '50%',
      right: 0,
      bottom: 0,
      height: '100%',
      borderRadius: 0,
      transform: 'translateY(-50%)',
      cursor: 'grab',
      fallbacks: {
        cursor: 'move'
      }
    }
  };
});

exports['default'] = (0, _reactSortableHoc.SortableHandle)((_temp = _class = function (_PureComponent) {
  _inherits(SortableHandle, _PureComponent);

  function SortableHandle() {
    _classCallCheck(this, SortableHandle);

    return _possibleConstructorReturn(this, (SortableHandle.__proto__ || Object.getPrototypeOf(SortableHandle)).apply(this, arguments));
  }

  _createClass(SortableHandle, [{
    key: 'render',
    value: function () {
      function render() {
        var classes = this.context.styleManager.render(styleSheet);

        return _react2['default'].createElement(
          _IconButton2['default'],
          {
            className: (0, _classnames2['default'])(classes.sortableHandle, 'cursorGrabbing'),
            'data-sortableHandle': true,
            tabIndex: '-1'
          },
          _react2['default'].createElement(_Drag2['default'], null)
        );
      }

      return render;
    }()
  }]);

  return SortableHandle;
}(_react.PureComponent), _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _class.displayName = 'SortableHandle', _temp), {
  withRef: true
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/makeSortable/SortableHandle.js
// module id = 657
// module chunks = 32